export default __webpack_public_path__ + "static/media/dimitard_xl.c5eaf434.jpg";